<template>
	<div>
		<div class="container-fluid">
			<nav class="navbar navbar-expand-lg navbar-light mb-4 mt-2">
				<h1 class="h3 mb-0 text-gray-800 mr-4">
					Receita
			  	</h1>
			  	<button 
					class="navbar-toggler" 
					type="button" 
					data-toggle="collapse" 
					data-target="#navbarReceita" 
					aria-controls="navbarReceita" 
					aria-expanded="false" 
					aria-label="Toggle navigation">
			    	<span class="navbar-toggler-icon"></span>
			  	</button>
			  	<div class="collapse navbar-collapse" id="navbarReceita">
			  		<div class="mr-auto mt-4">
			  			<div class="form-group col-md-12">
							<input-date 
								time="1000"
								@date="setDate">
							</input-date>
						</div>
			  		</div>
			  		<div class="row"> 
			  			<button
						    class="btn btn-success"
						    @click="create()">
						    Efetuar Pagamento
						</button>
			  		</div>
			  	</div>
			</nav>
			<!-- Totais -->
			<receita-total
				v-if="date"
				:key="chartReceitaKey"
				:date="date">
			</receita-total>
			<!-- Chart -->
			<div class="row mt-4">
				<div class="col-md-12">
		        	<chart-receita 
		        		v-if="date"
		        		:dados="dadosChart"
		        		:date="date"
		        		:key="chartReceitaKey">
		        	</chart-receita>
		        </div>
		    </div>
		    <!-- Registros -->
		    <receita-card
		    	v-if="date"
		    	:receitaTableKey="receitaTableKey"
		    	:date="date"
		    	@show="show"
		        @update="update"
		        @destroy="destroy">	
		    </receita-card>
		</div>
		<!-- Create -->
		<receita-create 
			:key="receitaTableKey"
			@reload="reload">
		</receita-create>
		<!-- Update -->
		<receita-update 
			:key="receitaUpdateKey"
			:dado_id="dado_id"
			@reload="reload">
		</receita-update>
		<!-- Delete -->
		<bsh-confirm 
        	modal_id="confirm_destroy_receita" 
        	:dado_id="dado_id" 
        	title="Deseja realmente cancelar este pagamento?" 
        	btn="Excluir" 
        	btnStyle="btn-danger" 
        	method="delete" 
        	:rota="$url+'/api/adm/receita/destroy/'" 
        	@reload="reload">
        </bsh-confirm>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				dado_id: 0,
				dadosChart: [],
				date: '',
				receitaTableKey: 0,
				receitaUpdateKey: 1,
				chartReceitaKey: 2,
			}
		},
		methods: {
			setDate(date){
				this.date = date;
				this.reload();
			},
			getDadosChart(){
				if(this.date){
					axios.get(this.$url+'/api/adm/painel/data-chart?data='+this.date)
		            .then(response => {
		            	this.dadosChart = response.data
		            	this.reload()
		            })
		            .catch(error => {
		            	console.log(error)
		            });
				}
			},
			create(){
				$('#create_receita').modal('show');
			},
			show(dado_id){
				this.$router.push('/adm/pedidos/show/'+dado_id)
			},
			update(id){
				this.dado_id = id;
				$('#update_receita').modal('show');
			},
			destroy(id){
				this.dado_id = id;
				$('#confirm_destroy_receita').modal('show');
			},
			reload(){
				this.receitaTableKey += 1;
				this.receitaUpdateKey += 1;
				this.chartReceitaKey += 1
			},
		}
	}
</script>